import logoMark from '../assets/img/black_logo.png';

function TrustedPartnerIcon() {
  return (
    <svg className="h-6 w-6 text-gold" fill="none" viewBox="0 0 24 24" strokeWidth={1.75} stroke="currentColor">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z"
      />
    </svg>
  );
}

function GlobeIcon() {
  return (
    <svg className="h-6 w-6 text-gold" fill="none" viewBox="0 0 24 24" strokeWidth={1.75} stroke="currentColor">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 21a9.004 9.004 0 008.716-6.747M12 21a9.004 9.004 0 01-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 017.843 4.582M12 3a8.997 8.997 0 00-7.843 4.582m15.686 0A11.953 11.953 0 0112 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0121 12c0 .53-.043 1.05-.127 1.562"
      />
    </svg>
  );
}

const expertise = [
  'Visa Processing & Immigration',
  'World wide holiday packages',
  'Education Consultancy',
  'Premium Lifestyle Services',
  'Corporate Solutions (Information Technology & AI)',
];

export default function WhoWeAre() {
  return (
    <section
      className="relative border-t border-white/10 bg-gradient-to-b from-navy-900 to-navy-950 py-16 sm:py-24"
      aria-labelledby="who-we-are-heading"
    >
      <div
        className="pointer-events-none absolute inset-0 z-[1] bg-gradient-to-b from-navy-950/95 via-navy-900/80 to-navy-950/70"
        aria-hidden
      />
      <div className="relative z-10 mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid gap-12 lg:grid-cols-12 lg:items-start lg:gap-14">
          {/* Left column */}
          <div className="lg:col-span-7">
            <h2
              id="who-we-are-heading"
              className="font-sans text-3xl font-bold tracking-tight text-white md:text-4xl"
            >
              Who We{' '}
              <span className="font-serif text-3xl font-semibold italic text-gold md:text-4xl">Are</span>
            </h2>
            <div className="mt-4 h-px w-16 bg-gradient-to-r from-transparent via-gold/80 to-transparent" aria-hidden />

            <p className="mt-6 text-justify text-base leading-relaxed text-white/80 sm:text-[1.05rem]">
              RAYAN STAR Consultancy &amp; Services W.L.L. is a premier consultancy firm headquartered in the
              heart of Bahrain. We have established ourselves as a{' '}
              <span className="rounded-sm bg-gold/15 px-1 font-semibold text-white">
                trusted multi-sector service provider
              </span>
              , delivering comprehensive solutions that span across Immigration, Visa, Education, Limousine,
              Travel, IT, AI automation and lifestyle services.
            </p>

            <div className="mt-6 rounded-2xl border border-white/10 bg-navy-800/50 p-5 sm:p-6">
              <p className="text-justify text-sm leading-relaxed text-white/75 sm:text-base">
                With years of experience and a deep understanding of regional and international requirements, we
                provide{' '}
                <span className="font-semibold text-gold-dark">end-to-end support</span> that ensures seamless
                experiences for our clients. From initial consultation to final delivery, our team is committed to
                excellence at every step.
              </p>
            </div>

            <div className="mt-8 grid gap-4 sm:grid-cols-2">
              <div className="group relative overflow-hidden rounded-2xl border border-slate-200 bg-white p-5 shadow-md transition hover:-translate-y-1 hover:border-gold/40 hover:shadow-lg">
                <div
                  className="pointer-events-none absolute inset-0 opacity-0 transition-opacity duration-300 group-hover:opacity-100"
                  style={{
                    background:
                      'radial-gradient(480px 220px at 50% 0%, rgba(212,175,55,0.12), transparent 55%)',
                  }}
                  aria-hidden
                />
                <div className="relative">
                  <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-gold/10 ring-1 ring-gold/25">
                    <TrustedPartnerIcon />
                  </div>
                  <h3 className="mt-4 font-sans text-lg font-semibold text-navy">Trusted Partner</h3>
                  <p className="mt-2 text-sm leading-relaxed text-navy/65">
                    Relied upon by clients across the GCC region.
                  </p>
                </div>
              </div>
              <div className="group relative overflow-hidden rounded-2xl border border-slate-200 bg-white p-5 shadow-md transition hover:-translate-y-1 hover:border-gold/40 hover:shadow-lg">
                <div
                  className="pointer-events-none absolute inset-0 opacity-0 transition-opacity duration-300 group-hover:opacity-100"
                  style={{
                    background:
                      'radial-gradient(480px 220px at 50% 0%, rgba(212,175,55,0.12), transparent 55%)',
                  }}
                  aria-hidden
                />
                <div className="relative">
                  <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-gold/10 ring-1 ring-gold/25">
                    <GlobeIcon />
                  </div>
                  <h3 className="mt-4 font-sans text-lg font-semibold text-navy">Global Reach</h3>
                  <p className="mt-2 text-sm leading-relaxed text-navy/65">
                    Extensive network across international markets.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Right column */}
          <div className="lg:col-span-5">
            <div className="overflow-hidden rounded-2xl bg-gradient-to-br from-gold via-gold to-gold-dark p-6 shadow-lg ring-1 ring-gold/30 sm:p-8">
              <img
                src={logoMark}
                alt="RAYANSTAR CONSULTANCY & SERVICES CO. W.L.L."
                className="mx-auto h-auto w-full max-w-[260px] object-contain drop-shadow-sm"
              />
            </div>

            <div className="mt-6 rounded-2xl border border-slate-200 bg-white p-6 shadow-md">
              <h3 className="font-sans text-lg font-semibold text-gold">Our Core Expertise</h3>
              <ul className="mt-5 space-y-3 text-sm text-navy/80">
                {expertise.map((item) => (
                  <li key={item} className="flex gap-3">
                    <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-gold" aria-hidden />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
